module.exports = __webpack_public_path__ + "img/mileage.caca05da.png";